<p-panel
  id="jobHistorys"
  [ngClass]="{
    'timeline-panel': organisationTypeId != 2,
    'timeline-panel-customer': organisationTypeId == 2
  }"
>
  <p-header>
    <div class="event-header">
      <button class="clear-button" type="button" (click)="loadHistorys()">
        <i class="fa fa-refresh clear-button-refresh-icon"></i>Refresh
      </button>
      Job History
      <span class="clear-button-clear-span"></span>
    </div>
  </p-header>

  <p-progressBar
    *ngIf="isLoading"
    mode="indeterminate"
    class="ui-progressbar-indeterminate"
  ></p-progressBar>

  <div class="flex flex-column" style="height: 100%">
    <div class="event-filter-options">
      <div *ngIf="organisationTypeId == 1" class="flex-shrink-1 pt-1">
        <input
          type="checkbox"
          id="engineius"
          [(ngModel)]="filterEngineius"
          (change)="filterEventTypeChanged()"
        /><label>Engineius</label>
        <input
          type="checkbox"
          id="customer"
          [(ngModel)]="filterCustomer"
          (change)="filterEventTypeChanged()"
        /><label>Customer</label>
        <input
          type="checkbox"
          id="supplier"
          [(ngModel)]="filterSupplier"
          (change)="filterEventTypeChanged()"
        /><label>Supplier</label>
      </div>
      <div *ngIf="organisationTypeId == 1" class="flex-shrink-1">
        <input
          pInputText
          placeholder="Search history"
          class="event-filter-options-search-filter"
          [(ngModel)]="filterHistorySearch"
          (keyup)="filterEventTypeChanged()"
        />
      </div>
      <div class="flex-shrink-1">
        <p-dropdown
          appendTo="body"
          id="eventType"
          placeholder="Select an event type"
          (onChange)="filterEventTypeChanged()"
          [options]="eventTypes"
          [(ngModel)]="selectedEventType"
          autoWidth="false"
          [style]="{
            width: '190px',
            'min-height': '25px',
            'overflow-x': 'hidden',
            'margin-right': '5px'
          }"
        ></p-dropdown>

        <p-dropdown
          *ngIf="eventTasks.length > 2"
          appendTo="body"
          id="taskType"
          placeholder="Select Task"
          (onChange)="filterEventTypeChanged()"
          [options]="eventTasks"
          [(ngModel)]="selectedEventTask"
          autoWidth="false"
          [style]="{ width: '110px', 'overflow-x': 'hidden' }"
        ></p-dropdown>
      </div>
    </div>

    <div style="flex-grow: 1; overflow-y: auto; padding-top: 5px">
      <div class="history-container" *ngFor="let history of historys">
        <div class="ui-g">
          <div class="ui-g-4 event-left">
            <div class="flex flex-wrap grid-gap-5">
              <div class="flex-grow-1">
                <span class="event-time" pTooltip="{{ history.eventDateTime }}">{{
                  history.created | datex : "ddd DD MMM 'YY HH:mm"
                }}</span>
                <div class="history-organisation">&bull; {{ history.organisation }}</div>
              </div>
              <div class="flex-shrink-1">
                <span>
                  <img
                    style="width: 30px"
                    class="event-tag-icon"
                    src="assets/images/jobhistory/{{ history.tagType }}.png"
                    [pTooltip]="history.area"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="ui-g-8">
            <div style="display: flex">
              <div style="flex-grow: 1; margin-left: 3px">
                <div style="padding-right: 10px">
                  <div class="event-owner" pTooltip="{{ history.user }}">
                    {{ history.userFullName }}
                  </div>
                  <div class="event-text">{{ history.description }}</div>
                </div>
              </div>
              <div style="flex: 0 0 130px">
                <div *ngIf="history.taskName" class="event-task-name">
                  {{ getRegPlate(history.taskName) }}
                </div>
                <div class="event-area">{{ history.area }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="event-actions" style="flex-shrink: 1">
      <div class="event-note-container">
        <div>New Note</div>
        <textarea
          class="event-note-area"
          ng-model-options="{ updateOn: 'blur' }"
          [(ngModel)]="newHistoryNote"
          [maxlength]="750"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          pInputTextarea
        ></textarea>
      </div>

      <div class="event-checkbox-container">
        <div *ngIf="organisationTypeId == 1">
          <div class="event-type-checkbox">
            <p-checkbox
              [(ngModel)]="newNoteIsEngineius"
              binary="true"
              label="Engineius"
            ></p-checkbox>
          </div>
          <div class="event-type-checkbox">
            <p-checkbox [(ngModel)]="newNoteIsCustomer" binary="true" label="Customer"></p-checkbox>
          </div>
          <div class="event-type-checkbox">
            <p-checkbox [(ngModel)]="newNoteIsSupplier" binary="true" label="Supplier"></p-checkbox>
          </div>
        </div>
        <button
          type="button"
          (click)="addNewNote()"
          pButton
          icon="fa ui-icon-add"
          label="Add Note"
          class="ui-button green-btn event-note-add-button"
          [disabled]="
            !newHistoryNote ||
            (organisationTypeId == 1 &&
              !newNoteIsEngineius &&
              !newNoteIsCustomer &&
              !newNoteIsSupplier)
          "
        ></button>
      </div>
    </div>
  </div>
</p-panel>
